export default "__VITE_ASSET__f6792f88__"